import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  type QuickBooksImportErrorDetailConstructor,
  type QuickBooksImportErrorEntry,
  QuickBooksImportErrorDetail,
} from './QuickBooksImportErrorDetail'
import { QuickBooksImportErrorCodes } from '../enums/QuickBooksImportErrorCodeEnum'

export const QuickBooksImportErrorEntryFactory =
  Factory.Sync.makeFactory<QuickBooksImportErrorEntry>({
    id: Factory.each(() => faker.random.uuid()),
    number: Factory.each(() => String(faker.random.number(9999))),
    type: 'Expense',
    name: Factory.each(() => faker.company.companyName()),
  })

export const QuickBooksImportErrorDetailConstructorFactory =
  Factory.Sync.makeFactory<QuickBooksImportErrorDetailConstructor>({
    code: QuickBooksImportErrorCodes.DUPLICATE_ENTRIES_0003,
    message: Factory.each(() => faker.lorem.sentence()),
    entries: Factory.each(() => [QuickBooksImportErrorEntryFactory.build()]),
  })

export const QuickBooksImportErrorDetailFactory = EntityFactory(
  QuickBooksImportErrorDetail,
  QuickBooksImportErrorDetailConstructorFactory
)
